
const FindTotalInterest = (prePaymentFactor, postPaymentFactor, term, loanAmount, loanName) => {

  let prePayment = Math.round(loanAmount * prePaymentFactor)
  let postPayment = Math.round(loanAmount * postPaymentFactor)
  let firstPayment = 17
  let totalPayments = term * 12

  if (loanName === 'Dividend') {
    firstPayment = 15
  }

  let secondPayment = totalPayments - firstPayment

  return ((prePayment * firstPayment) + (postPayment * secondPayment)) - loanAmount

}
export default FindTotalInterest